import React from "react";

// Pixel art icon components
// These SVG paths are from pixelarticons (https://github.com/halfmage/pixelarticons)
export const PixelGamepadIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block"
  >
    <path d="M2 7H22V17H2V7ZM4 9V15H20V9H4ZM9 11H11V13H13V11H15V13H13V15H11V13H9V15H7V13H9V11Z" />
  </svg>
);

export const PixelBoltIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block"
  >
    <path d="M13 3V11H18L11 21V13H6L13 3Z" />
  </svg>
);

export const PixelClockIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block relative -top-px"
  >
    <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12 6C12.5523 6 13 6.44772 13 7V12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12V7C11 6.44772 11.4477 6 12 6Z" />
  </svg>
);

export const PixelUserIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block relative -top-px"
  >
    <path d="M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12ZM12 14C7.58172 14 4 16.6863 4 20V22H20V20C20 16.6863 16.4183 14 12 14Z" />
  </svg>
);

// New chat role icons
// PixelWizardIcon removed - unused

export const PixelPlayerIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block"
  >
    <path d="M12 3L14 9H21L16 12.5L18 19L12 15L6 19L8 12.5L3 9H10L12 3Z" />
  </svg>
);

export const PixelDiceIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block"
  >
    <path
      fillRule="evenodd"
      d="M4 4H20V20H4V4ZM6 6V18H18V6H6ZM8 8H10V10H8V8ZM14 8H16V10H14V8ZM11 11H13V13H11V11ZM8 14H10V16H8V14ZM14 14H16V16H14V14Z"
    />
  </svg>
);

export const PixelSystemIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block"
  >
    <path d="M7 4V2H17V4H7ZM7 22V20H17V22H7ZM4 8H2V16H4V8ZM22 8H20V16H22V8ZM5 6H19V18H5V6ZM7 8V16H17V8H7Z" />
  </svg>
);

// Add XP icon component
export const PixelXPIcon: React.FC<{ className?: string }> = ({
  className = "",
}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="currentColor"
    className={`inline-block ${className}`}
  >
    <path d="M12 2L14.2 7.4H20L15.5 11.3L17.3 17L12 13.4L6.7 17L8.5 11.3L4 7.4H9.8L12 2Z" />
  </svg>
);

// Add pixel art status icons
export const PixelReadyIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block"
  >
    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
  </svg>
);

export const PixelNotReadyIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block"
  >
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" />
  </svg>
);

// PixelWaitingIcon removed - unused

// PixelDisconnectedIcon removed - unused

// Add a candle/flame icon for narrative messages
export const PixelCandleIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block"
  >
    <path d="M12 2C12 2 14 5 14 8C14 10.2091 12.2091 12 10 12C7.79086 12 6 10.2091 6 8C6 5 8 2 8 2C8 2 9 3 10.5 3C12 3 12 2 12 2ZM16 22H2V21C2 18 4.5 14 9 14C13.5 14 16 18 16 21V22ZM22 19H20V17H18V15H20V13H22V15H24V17H22V19Z" />
  </svg>
);

// Add a star icon for achievements
export const PixelStarIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block"
  >
    <path d="M12 2L14.2451 8.90983H21.5106L15.6327 13.1803L17.8779 20.0902L12 15.82L6.12215 20.0902L8.36729 13.1803L2.48944 8.90983H9.75486L12 2Z" />
  </svg>
);

// Add gear icon for settings
export const PixelGearIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block"
  >
    <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15ZM12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17ZM2 12C2 13.5 2 15 2.5 16L4.5 17.5L2.5 21L4.5 22.5C6 20.5 8 20.5 9.5 22.5L12 21L14.5 22.5C16 20.5 18 20.5 19.5 22.5L21.5 21L19.5 17.5L21.5 16C22 15 22 13.5 22 12C22 10.5 22 9 21.5 8L19.5 6.5L21.5 3L19.5 1.5C18 3.5 16 3.5 14.5 1.5L12 3L9.5 1.5C8 3.5 6 3.5 4.5 1.5L2.5 3L4.5 6.5L2.5 8C2 9 2 10.5 2 12Z" />
  </svg>
);

// Calendar icon for dates
export const PixelCalendarIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block relative -top-px"
  >
    <path d="M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V8H19V19ZM7 10H9V12H7V10ZM11 10H13V12H11V10ZM15 10H17V12H15V10ZM7 14H9V16H7V14ZM11 14H13V16H11V14ZM15 14H17V16H15V14Z" />
  </svg>
);

// Globe/World icon
export const PixelGlobeIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block relative -top-px"
  >
    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 19.93C11.26 19.67 9.74 18.76 8.66 17.47L10.24 16.24C10.89 17.11 11.39 17.97 11.85 18.88L13 19.93ZM15.76 16.24L17.34 17.47C16.26 18.76 14.74 19.67 13 19.93L12.15 18.88C12.61 17.97 13.11 17.11 13.76 16.24H15.76ZM17.93 13C17.67 14.74 16.76 16.26 15.47 17.34L16.24 15.76C17.11 15.11 17.97 14.61 18.88 14.15L19.93 13H17.93ZM17.93 11H19.93L18.88 9.85C17.97 9.39 17.11 8.89 16.24 8.24L15.47 6.66C16.76 7.74 17.67 9.26 17.93 11ZM13 4.07C14.74 4.33 16.26 5.24 17.34 6.53L15.76 7.76C15.11 6.89 14.61 6.03 14.15 5.12L13 4.07ZM11 4.07L10.15 5.12C9.69 6.03 9.19 6.89 8.54 7.76L6.96 6.53C8.04 5.24 9.56 4.33 11.3 4.07H11ZM4.07 11H6.07L5.12 12.15C6.03 12.61 6.89 13.11 7.76 13.76L6.53 15.34C5.24 14.26 4.33 12.74 4.07 11ZM4.07 13C4.33 14.74 5.24 16.26 6.53 17.34L7.76 15.76C6.89 15.11 6.03 14.61 5.12 14.15L4.07 13ZM11 19.93C9.26 19.67 7.74 18.76 6.66 17.47L8.24 16.24C8.89 17.11 9.39 17.97 9.85 18.88L11 19.93ZM12 8C9.79 8 8 9.79 8 12C8 14.21 9.79 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM12 14C10.9 14 10 13.1 10 12C10 10.9 10.9 10 12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14Z" />
  </svg>
);

// Edit/Pencil icon
export const PixelEditIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block relative -top-px"
  >
    <path d="M3 17.25V21H6.75L17.81 9.94L14.06 6.19L3 17.25ZM20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C17.98 2.9 17.35 2.9 16.96 3.29L15.12 5.12L18.87 8.87L20.71 7.04Z" />
  </svg>
);

// Delete/Trash icon
export const PixelDeleteIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block relative -top-px"
  >
    <path d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM8 9H16V19H8V9ZM15.5 4L14.5 3H9.5L8.5 4H5V6H19V4H15.5Z" />
  </svg>
);

// Play/Start icon
export const PixelPlayIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block relative -top-px"
  >
    <path d="M8 5V19L19 12L8 5Z" />
  </svg>
);

// Lightbulb icon for feedback/ideas
export const PixelLightbulbIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block"
  >
    <path d="M12 2C8.14 2 5 5.14 5 9C5 11.38 6.19 13.47 8 14.74V17C8 17.55 8.45 18 9 18H15C15.55 18 16 17.55 16 17V14.74C17.81 13.47 19 11.38 19 9C19 5.14 15.86 2 12 2ZM14 13.7V16H10V13.7C8.84 13 8 11.82 8 10.5C8 8.57 9.57 7 11.5 7C13.43 7 15 8.57 15 10.5C15 11.82 14.16 13 13 13.7ZM13 10H11V8H13V10ZM13 12H11V11H13V12ZM15 20H9V22H15V20Z" />
  </svg>
);

// Sword icon for features/weapons
export const PixelSwordIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block"
  >
    <path d="M6.92 5H5L10 10L7 13L8.42 14.42L11.42 11.42L16.42 16.42L15 17.84L16.42 19.26L17.84 17.84L19.26 19.26L20.68 17.84L19.26 16.42L17.84 15L19.26 13.58L17.84 12.16L12.84 7.16L15.84 4.16L14.42 2.74L11.42 5.74L6.92 5ZM8.42 6.42L10.42 8.42L9.42 9.42L7.42 7.42L8.42 6.42Z" />
  </svg>
);

// Sparkle/Star icon for special announcements
export const PixelSparkleIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block"
  >
    <path d="M12 0L14 8L22 10L14 12L12 20L10 12L2 10L10 8L12 0Z" />
  </svg>
);

// Close/X icon
export const PixelCloseIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block"
  >
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z" />
  </svg>
);

// Question mark/Help icon
export const PixelQuestionIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block"
  >
    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 19H11V17H13V19ZM15.07 11.25L14.17 12.17C13.45 12.9 13 13.5 13 15H11V14.5C11 13.4 11.45 12.4 12.17 11.67L13.41 10.41C13.78 10.05 14 9.55 14 9C14 7.9 13.1 7 12 7C10.9 7 10 7.9 10 9H8C8 6.79 9.79 5 12 5C14.21 5 16 6.79 16 9C16 10.2 15.54 11.28 14.83 12.08L13.83 13.08C13.36 13.55 13 14.22 13 15H11C11 13.77 11.36 12.72 12.07 12.25H15.07Z" />
  </svg>
);

// Arrow left/back icon
export const PixelArrowLeftIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block"
  >
    <path d="M10 9V5L3 12L10 19V14.9C15 14.9 18.5 16.5 21 20C20 15 17 10 10 9Z" />
  </svg>
);

// Chat/Message icon
export const PixelChatIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block"
  >
    <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H6L4 18V4H20V16Z" />
  </svg>
);

// User group/Players icon
export const PixelUserGroupIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block"
  >
    <path d="M16 11C17.66 11 19 9.66 19 8C19 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 11 9.66 11 8C11 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z" />
  </svg>
);

// Warning/Alert icon
export const PixelWarningIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="inline-block"
  >
    <path d="M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z" />
  </svg>
);
